export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/deny-34cde021e2558e75f23710f83071273a.svg";